import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Image } from 'semantic-ui-react';

const IclusigLogo = props => {
  let imgLink, hrefLink;

  if (props.imgLink === 'iclusig') {
    imgLink = 'ICLUSIG_logo.png';
    hrefLink = 'https://www.iclusig.com/pdf/ICLUSIG-Prescribing-Information.pdf';
  }

  const logoImg = (
    <Image
      src={ `/images/${imgLink}` }
      verticalAlign={ props.verticalAlign }
      alt="ICLUSIG logo"
    />
  );
  return (
    <div className="iclusig-logo">
      { props.isLink
        ? (
          <Link to={ props.linkTo } className={ props.classTracking }>
            { logoImg }
          </Link>
        )
        : (
          logoImg
        ) }
      <span>Please see full <a href={ hrefLink } target="_blank" rel="noopener noreferrer">Prescribing Information</a>, including <a href={ hrefLink } target="_blank" rel="noopener noreferrer" className="no-underline">Boxed Warning</a>.</span>
    </div>
  );
};

IclusigLogo.propTypes = {
  verticalAlign: PropTypes.string,
  isLink: PropTypes.bool,
  classTracking: PropTypes.string,
  linkTo: PropTypes.string,
};

export default IclusigLogo;
